import { useMemo, useState } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { Campaign } from "@l2r-front/l2r-proptypes"
import { I18N_NAMESPACE } from "@l2r-front/l2r-shared-campaign"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { statusesSettings } from "../../constants/status"
import { useCampaignItemsCount } from "../../hooks/useCampaignItemsCount"
import { useIsCampaignWriter } from "../../hooks/useIsCampaignWriter"

import * as Styled from "./StatusSelector.styled"

interface StatusSelectorProps {
    className?: string
    campaign: Campaign
    onStatusChange: (status: number) => void
}

export function StatusSelector(props: StatusSelectorProps) {

    const {
        className,
        campaign,
        onStatusChange
    } = props

    const isMobile = useIsMobileDevice()
    const { t } = useTranslation(I18N_NAMESPACE)
    const isCampaignWriter = useIsCampaignWriter(campaign)
    const campaignItemsCount = useCampaignItemsCount(campaign)

    const displayedStatuses = useMemo(() => {
        if (!campaign) {
            return []
        }
        return statusesSettings[campaign.status].statusTransitions
    }, [campaign])

    const isDisabled = useMemo(() => {
        if (!campaign) {
            return true
        }
        return !isCampaignWriter || !campaignItemsCount
    }, [campaign, isCampaignWriter, campaignItemsCount])

    const [anchorEl, setAnchorEl] = useState(null)
    const open = !!anchorEl

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }


    if (!campaign) {
        return null
    }

    return (
        <Styled.SelectorButtonContainer className={className} id="status-selector-container" isMobile={isMobile}>
            <Styled.SelectorButton
                disabled={isDisabled}
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
            >
                {t(I18N_NAMESPACE, statusesSettings[campaign.status].statusLabel)} {!isDisabled ? <Styled.ArrowDownIcon /> : null}
            </Styled.SelectorButton>
            <Styled.Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        "aria-labelledby": "basic-button",
                    },
                }}
            >
                {displayedStatuses.map(({ status, icon }) => {
                    return <Styled.MenuItem
                        onClick={() => {
                            onStatusChange(status)
                            handleClose()
                        }}
                        key={status}>
                        {icon} {`${t(I18N_NAMESPACE, statusesSettings[campaign.status].statusLabel)} > ${t(I18N_NAMESPACE, statusesSettings[status].statusLabel)}`}
                    </Styled.MenuItem>
                })}
            </Styled.Menu>
        </Styled.SelectorButtonContainer>)
}